<template>
  <validation-observer ref="simpleRules">
    <team-types-form  />
    <save-button
      :save-action="submitForm"
      :is-disabled="submitStatus.status"
    />
  </validation-observer>
</template>
<script>
import { ValidationObserver, localize } from 'vee-validate'
// eslint-disable-next-line no-unused-vars
import { required } from '@validations'
import SaveButton from '@/layouts/components/common/SaveButton.vue'
// eslint-disable-next-line import/extensions
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import TeamTypesForm from "@/views/Admin/Defines/TeamTypes/TeamTypesForm.vue";

export default {
  name: 'Add',
  components: {
    TeamTypesForm,
    SaveButton,
    ValidationObserver,
  },

  computed: {
    dataItem() {
      return this.$store.getters['teamTypes/dataItem']
    },
    submitStatus() {
      return this.$store.getters['teamTypes/submitStatus']
    },
    saveData() {
      return this.$store.getters['teamTypes/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.submitStatus.status = false
       // this.$router.push('/admin/defines/teamTypes')
        this.$router.push({ name: 'TeamTypes' });
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
    },
  },
  created() {
    this.$store.dispatch('teamTypes/resetDataItem')
    localize('tr')
  },

  methods: {
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.submitStatus.status = true
          this.$store.dispatch('teamTypes/saveData', this.dataItem)
        } else {
          this.showToast({
            title: 'Uyarı!',
            icon: 'XIcon',
            text: 'Lütfen tüm alanları doldurun.',
            variant: 'danger',
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>

<style scoped>

</style>
